import React from 'react';
import { Marker, Popup } from 'react-leaflet';

/*
 * Zeigt einen Ort (location) als Marker. Pro Ort genau ein Marker,
 * unabhaengig davon, wie viele Aktivitaeten dort stattfinden.
 * Rein informativ – keine Navigation/Funktionalitaet.
 */
const LocationMarker = ({ location }) => {
  const { position, locationName, address, activities } = location;
  if (!position) return null;

  const count = activities.length;

  return (
    <Marker position={position}>
      <Popup>
        <strong>{locationName || address || 'Unbekannter Ort'}</strong>
        {locationName && address && (
          <div style={{ color: '#6b7280', fontSize: '0.85em', marginTop: '2px' }}>{address}</div>
        )}
        <div style={{ marginTop: '6px', fontWeight: 600 }}>
          {count} {count === 1 ? 'Aktivität' : 'Aktivitäten'}
        </div>
        <ul style={{ margin: '4px 0 0', paddingLeft: '1.1em' }}>
          {activities.map((a) => (
            <li key={a.id}>{a.name}</li>
          ))}
        </ul>
      </Popup>
    </Marker>
  );
};

export default LocationMarker;
